import { h, Host, } from "@stencil/core";
/* OTHER LIBRARIES IMPORTS */
/* CUSTOM IMPORTS */
import { commonClassesNames } from "../../../common/classesNames";
import { KeyboardKeys as KK } from "../../../common/types";
export class GxgMenuSlimItem {
    constructor() {
        this.label = undefined;
        this.iconType = undefined;
        this.active = false;
        this.itemId = undefined;
        this.ellipsis = false;
        this.disabled = false;
    }
    // 2. REFERENCE TO ELEMENTS //
    el;
    listItem;
    // 3.STATE() VARIABLES //
    // 4.PUBLIC PROPERTY API | WATCH'S //
    // 5.EVENTS (EMIT) //
    /**
     * This events fires when the user presses up or down keys.
     */
    keyboardNavigation;
    /**
     * This events emits the item id, label, iconType, and a reference to itself
     */
    itemSelected;
    // 6.METHODS //
    // 7.LISTENERS //
    // 8.PUBLIC METHODS API //
    // 9.LOCAL METHODS //
    // 10.RENDER() FUNCTION //
    renderIcon() {
        return this.iconType ? (h("gxg-icon", { slot: "iconType", type: this.iconType, size: "small", color: this.iconTypeColor(), part: "icon" })) : null;
    }
    iconTypeColor = () => {
        if (this.disabled) {
            return "ondisabled";
        }
        else if (this.active) {
            return "negative";
        }
        else {
            return "disabled";
        }
    };
    buttonClickedHandler = () => {
        this.active = true;
        this.itemSelected.emit({
            id: this.itemId,
            ref: this.el,
            label: this.label,
            iconType: this.iconType,
        });
    };
    buttonKeyDownHandler = (e) => {
        if (e.key === KK.ARROW_DOWN || e.key === KK.ARROW_UP) {
            this.keyboardNavigation.emit({
                ref: this.el,
                key: e.key,
            });
        }
    };
    render() {
        return (h(Host, { class: { [commonClassesNames["DISABLED_CLASS"]]: this.disabled } }, h("li", { class: {
                "menu-item": true,
                "menu-item--shorter": this.iconType !== undefined,
                "menu-item--ellipsis": this.ellipsis,
                [commonClassesNames["DISABLED_CLASS"]]: this.disabled,
            }, ref: (el) => (this.listItem = el), part: "item" }, h("button", { class: "menu-item__button form-element", onClick: this.buttonClickedHandler, onKeyDown: this.buttonKeyDownHandler, part: "button" }, this.renderIcon(), h("span", { class: "menu-item__label", part: "label" }, this.label)))));
    }
    static get is() { return "gxg-menu-slim-item"; }
    static get encapsulation() { return "shadow"; }
    static get delegatesFocus() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["item.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The item label"
                },
                "attribute": "label",
                "reflect": false
            },
            "iconType": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The item iconType"
                },
                "attribute": "icon-type",
                "reflect": false
            },
            "active": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets the item as active or not"
                },
                "attribute": "active",
                "reflect": true,
                "defaultValue": "false"
            },
            "itemId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The item identifier"
                },
                "attribute": "item-id",
                "reflect": false
            },
            "ellipsis": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Prevents the the text from wrapping into more than one line, adding an ellipsis at the end. This property is set and inherited one the menu."
                },
                "attribute": "ellipsis",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disables the item"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "keyboardNavigation",
                "name": "keyboardNavigation",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This events fires when the user presses up or down keys."
                },
                "complexType": {
                    "original": "MenuItemFocusChange",
                    "resolved": "{ ref: HTMLGxgMenuSlimItemElement; key: string; }",
                    "references": {
                        "MenuItemFocusChange": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/menu-slim/item/item.tsx",
                            "id": "src/components/menu-slim/item/item.tsx::MenuItemFocusChange"
                        }
                    }
                }
            }, {
                "method": "itemSelected",
                "name": "itemSelected",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This events emits the item id, label, iconType, and a reference to itself"
                },
                "complexType": {
                    "original": "MenuItemSelected",
                    "resolved": "{ iconType?: string; id: string; label: string; ref: HTMLGxgMenuSlimItemElement; }",
                    "references": {
                        "MenuItemSelected": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/menu-slim/item/item.tsx",
                            "id": "src/components/menu-slim/item/item.tsx::MenuItemSelected"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=item.js.map
